$(document).ready(function () {
    $('.auto-reset-timer').each(function (){
        setInterval(() => {
            const targetDate = new Date($(this).data('counter-date'));
            const counter = getTimeDiff(targetDate, $(this));

            $(this).find('.counter-days .counter-value').text(padZero(counter.days));
            $(this).find('.counter-hours .counter-value').text(padZero(counter.hours));
            $(this).find('.counter-minutes .counter-value').text(padZero(counter.minutes));
            $(this).find('.counter-seconds .counter-value').text(padZero(counter.seconds));
            $(this).find('.auto-reset-timer__counters').addClass('visible');
        }, 1000);
    });

    function padZero(num) {
        return num.toString().padStart(2, '0');
    }

    function getTimeDiff(targetDate, $timer) {
        const now = new Date();
        let timeDiff = targetDate.getTime() - now.getTime();
        if (timeDiff <= 0) {
            const days_to_add = ($timer.data('reset-type') === 'daily') ? 1 : 7;
            targetDate.setDate(targetDate.getDate() + days_to_add);
            timeDiff = targetDate.getTime() - now.getTime();
        }

        if (timeDiff <= 0) {
            return {
                days: '00',
                hours: '00',
                minutes: '00',
                seconds: '00',
            }
        } else {
            return {
                days: Math.floor(timeDiff / (1000 * 60 * 60 * 24)),
                hours: Math.floor((timeDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
                minutes: Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60)),
                seconds: Math.floor((timeDiff % (1000 * 60)) / 1000),
            }
        }
    }
});